<main id="main">
  <section id="seven_page">
    <div class="seven_page_content">
      <div class="seven_page_text">
        <div class="info_header">
          <h1 class="title-black">
            Núcleo Interdisciplinar de Assistência Social, Educação, Cultura e
            Inovação INOVAR
          </h1>
          <!-- <h1 id="title_foundation">Gente que é Mais</h1> -->
        </div>

        <!-- <p>
          Criar área de atuação sócio-comunitária para definir ações da FPLF
          voltadas à justiça social. Como propósitos:
        </p> -->

        <p class="justificado">
          Congregando as dimensões social e comunitária, o INOVAR FPLF é um
          núcleo interdisciplinar dedicado a ampliar oportunidades para pessoas
          e grupos em contextos de vulnerabilidade. Integrando assistência
          social, educação, cultura e inovação, o Núcleo promove o
          acompanhamento socioeconômico e sociopedagógico, incentivando
          trajetórias de vida sustentáveis e o protagonismo social, juntamente
          com a potencialização da compreensão da realidade e do fortalecimento
          de identidade, do sentimento de pertencimento e da solidariedade,
          respeitando-se os interesses, motivações e perspectivas de vida de
          cada participante.
        </p>

        <p class="justificado">
          Entre os objetivos centrais do INOVAR FPLF estão: apoiar propostas
          sócio- comunitárias alinhadas às políticas de assistência social,
          compreender demandas e processos formativos, e promover ações que
          desenvolvam autonomia, ampliem conhecimentos e valorizem saberes
          locais.
        </p>

        <p class="justificado">
          As ações do INOVAR FPLF estruturam-se em laboratórios de formação e
          experimentação — Trajetórias de Vida, Informática em Práticas de
          Aplicações e Narrativas Visuais — que unem artes, ciências e
          pedagogias críticas. Neles, os participantes são convidados a refletir
          sobre seus caminhos, desenvolver competências e transformar ideias e
          práticas com propósito e compromisso social para o desenvolvimento de
          uma sociedade marcada pela justiça, verdade e solidariedade.
        </p>

        <p class="justificado">
          Voltado a jovens, lideranças comunitárias, educadores sociais e
          agentes culturais, o INOVAR FPLF acredita que imaginar futuros exige
          agir no presente. Cada iniciativa nasce do diálogo entre saberes
          locais e práticas inovadoras, promovendo inclusão, autonomia e
          transformação duradoura nos territórios onde atua.
        </p>

        <!-- <div style="margin-left: 0.75rem">
          <p>
            <strong>a)</strong> Mapear o impacto dos projetos apoiados pela FPLF
            na vida pessoal, familiar e na formação dos participantes.
          </p>

          <p>
            <strong>b)</strong> Identificar necessidades dos participantes para
            continuidade do desenvolvimento integral.
          </p>

          <p>
            <strong>c)</strong> Analisar possibilidades de aprofundar o apoio da
            FPLF e aprimorar o desenvolvimento dos participantes.
          </p>

          <p>
            <strong>d)</strong> Sistematizar a organização dos dados e a
            publicação das informações e resultados.
          </p>
        </div> -->

        <div class="info_header space_top">
          <h1 id="title_foundation">Equipe Inovar</h1>
        </div>

        <img
          class="equipe"
          src="../../../assets/PHOTO-2025-09-02-11-26-45.jpg"
          alt=""
        />

        <!-- <div class="info_header">
          <h1 id="title_foundation">Núcleo INOVAR</h1>
        </div> -->
      </div>
    </div>
  </section>
</main>
